export enum ProjectModalTypes {
    OPEN_PROJECT_MODAL = '[auth] OPEN_PROJECT_MODAL',
    CLOSE_PROJECT_MODAL = '[auth] CLOSE_PROJECT_MODAL',
    REACTIVE_PROJECT_COL = '[auth] REACTIVE_PROJECT_COL'
}